export default __webpack_public_path__ + "static/media/hero-section-boys-wave.f13c570c.png";